import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center text-slate-500"
      >
        Завантаження...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
